export const UEEPCI = [
  {
    UEEPCI_titulo: "Informe UEEPCI 2022",
    UEEPCI_url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/UEEPCI/.pdf",
    destacado: false,
  },
  {
    UEEPCI_titulo: "Informe UEEPCI 2023",
    UEEPCI_url:"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/UEEPCI/.pdf",
    destacado: false,
  },
  {
    UEEPCI_titulo: "Informe UEEPCI 2024",
    UEEPCI_url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/UEEPCI/.pdf",
    destacado: false,
  },
  {
    UEEPCI_titulo: "Informe UEEPCI 2025",
    UEEPCI_url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/UEEPCI/.pdf",
    destacado: false,
  },
  {
    UEEPCI_titulo: "Formato de Registro",
    UEEPCI_url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/UEEPCI/.pdf",
    destacado: false,
  },
  {
    UEEPCI_titulo: "Manifiesto Servidores Públicos",
    UEEPCI_url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/UEEPCI/.pdf",
    destacado: false,
  },
  {
    UEEPCI_titulo: "Manifiesto Personas Particulares",
    UEEPCI_url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/UEEPCI/.pdf",
    destacado: false,
  }, 
];